import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from './server-api/api-configuration';
import { StateService } from './state.service';
import { environment } from 'src/environments/environment';
import { LocaleStorageService } from './locale-storage.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent  implements OnInit {
  
  title = 'TGBAT-frontend';
    
  constructor(private apiConf: ApiConfiguration,
    public stateService: StateService,
    public localStorageService: LocaleStorageService)
    {
  
    }

  ngOnInit(): void { 
    console.log(`Application version is: version (from package.json)=${environment.version}`);  

    this.apiConf.rootUrl = environment.api_base;
    if (this.localStorageService.getData('remember_me') &&  this.localStorageService.getData('remember_me') === 'true')
    {
      this.stateService.setLoginFromLocalStorage();
      
    }
    else
    {
      this.stateService.setLogin(null, false);
    }
  }
}
